<template>
  <div class="header" :class="{ 'header-dark': isHeaderDark }">
    <transition-group name="fade-1s">
      <img
        v-if="isHeaderDark"
        key="logo-dark"
        class="logo"
        src="../../assets/img/logo.svg"
        alt="KCM"
        @click="goToHome()"
      />
      <img
        v-else
        class="logo"
        key="logo-white"
        src="../../assets/img/logo_white.svg"
        alt="KCM"
        @click="goToHome()"
      />
    </transition-group>
    <ul class="nav">
      <li>
        <router-link to="/about">
          <hr />
          {{ $t("nav1") }}
        </router-link>
      </li>
      <li>
        <router-link to="/kcm-group">
          <hr />
          {{ $t("nav2") }}
        </router-link>
      </li>
      <li>
        <router-link to="/products">
          <hr />
          {{ $t("nav3") }}
        </router-link>
      </li>
      <li>
        <router-link to="/sustainability">
          <hr />
          {{ $t("nav4") }}
        </router-link>
      </li>
      <li>
        <router-link to="/careers">
          <hr />
          {{ $t("nav5") }}
        </router-link>
      </li>
      <li>
        <router-link to="/news">
          <hr />
          {{ $t("nav6") }}
        </router-link>
      </li>
      <li>
        <router-link to="/contacts">
          <hr />
          {{ $t("nav7") }}
        </router-link>
      </li>
      <li>
        <router-link to="/life-recad" class="liferecad">
          <hr />
          <img src="@/assets/img/liferecad_logo.svg" alt="Life Recad" />
          {{ $t("nav8") }}
        </router-link>
      </li>
      <div class="socials-lng">
        <section class="socials-wrapper">
          <div class="share">
            <img
              class="share-img"
              :title="$t('socials')"
              src="@/assets/img/share.svg"
              alt=""
            />
            <div class="socials">
              <a
                href="https://youtube.com/playlist?list=PL70aEbI637XAx3-NeLqI6T0XGK4qOahQi"
                target="_blank"
                :title="$t('socials-yt')"
              >
                <img src="@/assets/img/yt.svg" alt="" />
              </a>
              <a
                href="https://www.facebook.com/people/%D0%A5%D0%BE%D0%BB%D0%B4%D0%B8%D0%BD%D0%B3-%D0%9A%D0%A6%D0%9C-2000/100057096234380/"
                target="_blank"
                :title="$t('socials-fb')"
              >
                <img src="@/assets/img/fb.svg" alt="" />
              </a>
              <a
                href="https://www.linkedin.com/company/kcm-ad/"
                target="_blank"
                :title="$t('socials-in')"
              >
                <img src="@/assets/img/in.svg" alt="" />
              </a>
            </div>
          </div>
        </section>

        <li class="lang-li" @click="changeLang()">
          <a>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="30"
              height="15.631"
              viewBox="0 0 30 15.631"
            >
              <g id="flat-world-map" transform="translate(0 -9.781)">
                <g
                  id="Group_1192"
                  data-name="Group 1192"
                  transform="translate(0 9.782)"
                >
                  <path
                    id="Path_4324"
                    data-name="Path 4324"
                    d="M9.984,19.659l1.234.6L10.513,21.7l-.706.107-.107.566L8.254,23.611l-.67,1.269.493.53L7.268,25.2l-.284-.706.811-3.28-.671-.6-.315-1.269.379-.621-.346.052-.492-.633-.424-.212-.987-.353-.812-1.269-.493-.917V14.156l-.811-1.375L1.8,12.146l-.635.353L0,13.064l.74-.6-.459-.107-.174-.6.528-.424-.528-.07.1-.388H.6l-.353-.53L1.2,9.782l1.728.954.637-.6,1.374.811,2.645-.284V12l-1.058.211-.212.566,1.023,1.092.247-.035.175-1.375.673-.035.28.774.353-.211.776,1.73-1.093.491-.846.46-.67.918v.459l-.248.035-.175-.494-.953.14-.212.6.246.353.352-.284.353.035-.176.5.422.03.142.528.285.095.21-.343,1.411.141.951.706Zm16.708-.314-.076.6-.506-.185.093-.322-.555-.046-.719.67-.763.277.185,1.037-.071.208.28.161,1.132-.28.439.256.208-.115.138.418.577.163.417-.256.23-1.244-.627-.625Zm-2.8-.58.6.115.278-.854-.163-.14-.809.509Zm1.847-.233.624.648.358.024.151-.138.508.322-.208-.439-.948-.461Zm1.133-5.246h-.162l-.023.832L26.268,15l-.532.392-.023.347.97-.577.046-.6.322-.3-.253-.206.138-.487Zm2.5,8.391.069.646-.716.671.462.046.414-.626.323-.438-.208-.023ZM13.912,11.949v.674l.468-.2.132-.206-.506-.974-.3.208.018.26-.281.339-.019.354h.338Zm4.228,7.93-.018.75.3.131.3-.9-.076-.376Zm10.394-7.843.023.533-.6.74-.023-.833.785-.948-.483.071-.626.508-.764-.046-.577.555.415.3L26.2,14.256l-.415.071-.256.369.115.486-.3.16L25.25,14.9l-.256-.348-.347.368.277.785-.392.718-.857.046-.184.3.392.577-.415.347-.426-.443-.015.417.372.417.162.739.464.165.626.254L23.5,19.042l-.486-.462-.438-.626.6.3-.277-.506-.057-.691-.264.067-.323-.692-.9.625v.4l-.324.322-.414-1.04-.461-.555-1.111-.208-.322-.275-.163.092.23.555.369-.185.486.37-1.432.855-.742-1.456-.155.027.756,1.729.74-.347-.23.81-.74.668.115.995-.416.322-.76,1.433-.764.139-.67-1.618.163-.739-.417-1.3-1.41.092-.787-.763.14-1.248.763-.925,1.479-.254.093.392.6.392.23-.322.918.235.237-.143.105-.345-.634-.107-.2-.354-.149-.076-.131.449-.283-.356.018-.3-.378-.3-.224-.112.019.3.469.318-.244.282-.336-.45-.243-.282-.562.282-.393.618-.6-.093-.037-.749.766.054-.242-.391-.151-.32.58-.188.318-.429.262-.02-.057-.242.168-.226.131.374.729.018.2-.525.283.095-.095-.355.435-.139-.135-.16-.394.11-.138-.336-.017,0,.012-.024-.057-.141.158-.112.138-.352L16.3,10.9l-.244.3-.2.447.227.242-.227.6-.337.131-.186-.6-.394.225-.187-.112.018-.58.338-.26.281-.693.712-.392,1.776.326c2.049-.215,5.767-.61,5.767-.61l6.134.866L30,11.44l-.834.464ZM18.012,14.379l-.973-.505-.3.524.131.242.563-.093.412.112Zm1.027.635-.091-.58-.189-.281.227-.094v-.28l-.581.318.2.524-.092.355Zm-8.381-4.546-.521-.143-.644.688.828,2.156.392.1.031-.7.265-.163.015-.266.273-.513-.191-.387Z"
                    transform="translate(0 -9.782)"
                    fill="#fff"
                  ></path>
                </g>
              </g>
            </svg>
            {{ $i18n.locale === "bg" ? "EN" : "BG" }}
          </a>
        </li>
      </div>
    </ul>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters(["isHeaderDark"]),
  },
  watch: {
    "$route.name"() {
      window.scrollTo(0, 0);
    },
  },
  methods: {
    goToHome() {
      this.$router.push("/");
    },
    saveLang() {
      localStorage.setItem("lang", this.$i18n.locale);
    },
    changeLang() {
      if (this.$i18n.locale === "bg") {
        this.$i18n.locale = "en";
      } else {
        this.$i18n.locale = "bg";
      }
      this.saveLang();
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  @extend %flex-center;
  justify-content: space-between;
  left: 0;
  padding: 20px $sidesPadding 0;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 10;
}

.logo {
  cursor: pointer;
  display: inline-block;
  left: $sidesPadding;
  position: absolute;
  top: 50%;
  @include transform(translateY(-50%));
  width: 276px;
}

.logo:hover {
  opacity: 0.9;
}

.nav {
  .socials-lng {
    align-items: center;
    display: flex;
    gap: 5px;
    margin-left: auto;
    width: fit-content;

    .socials-wrapper {
      display: flex;

      .share {
        display: flex;
        justify-content: flex-end;
        position: relative;
        padding: 10px 12px;

        img {
          @include transition(all 0.4s);

          &.share-img {
            object-fit: scale-down;
            @include transform(scale(1.1));
          }
        }

        &:hover {
          .share-img {
            @include transform(scale(0.95));
          }

          .socials {
            opacity: 1;
            top: 100%;

            a {
              img {
                margin-top: 0;
                @include transform(scale(1));
              }
            }
          }
        }
      }

      .socials {
        display: flex;
        flex-direction: column;
        gap: 10px;
        opacity: 0;
        top: 10px;
        right: 0;
        position: absolute;
        @include transition(all 0.3s);

        a {
          display: flex;
          flex-direction: column;

          img {
            margin-top: -30px;
            min-width: 40px;
            @include transform(scale(0.5));
          }

          &:hover {
            background: initial;
          }
        }
      }
    }
  }

  li {
    cursor: pointer;
    font-weight: 500;
    position: relative;
    text-align: right;
    white-space: nowrap;
    @include transition(all 1s);

    a {
      @extend %flex-center;
      color: $mainTextLight;
      padding: 4px;
      text-transform: uppercase;
      @include transition(all 1s);

      hr {
        border: 1px solid $mainTextLight;
        border-radius: 2px;
        height: 2px;
        margin-right: 20px;
        min-width: 50px;
        opacity: 0.5;
        @include transition(all 1s);
        width: 100%;
      }

      &.liferecad {
        hr {
          margin-right: 0;
        }
        > img {
          margin: -2px 2px;
        }
      }
    }
  }

  .lang-li {
    margin-left: auto;
    margin-top: 5px;
    width: 60px;

    svg {
      display: inline-block;
      height: 15px;
      margin-right: 5px;

      path {
        @include transition(all 1s);
        fill: #fff;
      }
    }
  }

  .router-link-active,
  a:hover {
    background-color: $mainTextLight;
    @include transition(all 0.3s);
    color: $mainColor;

    &.liferecad {
      background-color: $mainColor;
      color: $mainTextLight;
    }
  }

  .lang-li:hover {
    svg {
      path {
        fill: $mainColor;
      }
    }
  }
}

.header-dark {
  .nav {
    li {
      a {
        color: $mainColor;

        hr {
          border: 1px solid $mainColor;
        }
      }
    }

    .router-link-active,
    a:hover {
      background-color: $mainColor;
      color: $mainTextLight;
    }

    .lang-li {
      svg {
        path {
          fill: $mainColor;
        }
      }
    }

    .lang-li:hover {
      svg {
        path {
          fill: #fff;
        }
      }
    }
  }
}

.nav-mobile-toggle {
  display: none;
}

@media screen and (max-width: 1600px) {
  .header {
    padding: 20px $sidesPadding1600 0;
  }

  .logo {
    left: $sidesPadding1600;
  }

  .nav {
    li {
      a {
        font-size: 12px;
      }
    }
  }
}

@media screen and (max-width: 1440px) {
  .logo {
    width: 220px;
  }

  .nav {
    li {
      a {
        font-size: 11px;
      }
    }
  }
}

@media screen and (max-width: 1280px) {
  .header {
    display: none;
  }
}
</style>
